<template>
  <div class="cards">
    <b-container>
      <Card
        v-for="card in cards"
        :key="card.src"
        :title="card.title"
        :paragraph="card.paragraph"
        :src="card.src"
      ></Card>
    </b-container>
  </div>
</template>

<script>
import Card from "./card";

export default {
  components: {
    Card
  },
  props: {
    cards: Array
  }
};
</script>